import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromDatasetsStore from './datasets-store.reducer';
import { DatasetsStoreEffects } from './datasets-store.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        EffectsModule.forFeature([DatasetsStoreEffects]),
        StoreModule.forFeature(
            fromDatasetsStore.datasetsStoreFeatureKey,
            fromDatasetsStore.reducer
        ),
    ],
})
export class DatasetsStoreModule {}
